// EN
export const derivedRatesSection = {
  title: "Tariffe derivate",
  description:
    "Crea tariffe basate sui tuoi piani tariffari principali per connetterti con diverse OTA mantenendo un prezzo base centralizzato.",
  newRate: "Nuova tariffa derivata",
  loading: "Caricamento delle tariffe...",

  otaBadge: "OTA",
  otaLockedTitle: "Tariffa OTA: gestita da 'Connetti OTA'",
  salePaused: "Vendite in pausa",

  columns: {
    name: "Nome",
    adjustment: "Variazione",
    finalPrice: "Prezzo finale",
  },

  actions: {
    resumeTitle: "Riprendi le vendite su Channex",
    pauseTitle: "Metti in pausa le vendite su Channex (stop_sell)",
    edit: "Modifica",
    delete: "Elimina",
    protectedTitle: "Protetta: modificala o rimuovila da 'Connetti OTA'",
  },

  empty: {
    title: "Nessuna tariffa derivata",
    text: "Crea tariffe derivate basate sui tuoi piani tariffari principali per connetterti con le OTA",
    create: "Crea la prima tariffa derivata",
  },

  modal: {
    editTitle: "Modifica tariffa derivata",
    createTitle: "Nuova tariffa derivata",
    baseRatePlan: "Piano tariffario base",
    selectBasePlaceholder: "Seleziona un piano tariffario base",
    selectBaseHint:
      "Seleziona il piano tariffario da cui verrà calcolata questa tariffa derivata",
    nameLabel: "Nome della tariffa derivata",
    namePlaceholder: "es. tariffa Booking.com, tariffa Airbnb",
    nameHint: "Questo nome ti aiuterà a identificare la tariffa quando ti connetti con le OTA",
    adjustmentType: "Tipo di variazione",
    percentage: "Percentuale",
    fixedAmount: "Importo fisso",
    adjustmentValue: "Valore della variazione",
    adjustmentValueHint: "(usa valori negativi per gli sconti)",
    cancel: "Annulla",
    saving: "Salvataggio...",
    update: "Aggiorna",
    create: "Crea tariffa",
  },

  preview: {
    title: "Anteprima",
    basePrice: "Prezzo base",
    increment: "Aumento",
    discount: "Sconto",
    finalPrice: "Prezzo finale",
  },

  delete: {
    title: "Elimina tariffa derivata",
    warnStrong: "Questa azione non può essere annullata.",
    warnText:
      "Prima di eliminarla, assicurati che la tariffa {name} non sia collegata a nessuna OTA.",
    confirmLabel: "Digita il nome esatto per confermare:",
    confirmPlaceholder: "Digita esattamente il nome della tariffa",
    confirmHint:
      "Incolla o digita il nome esattamente come mostrato sopra per abilitare il pulsante di eliminazione.",
    cancel: "Annulla",
    processing: "Eliminazione...",
    confirm: "Elimina definitivamente",
  },

  pause: {
    resumeTitle: "Riprendi le vendite",
    pauseTitle: "Metti in pausa le vendite",
    resumeText:
      "{code} verrà inviato a Channex per i prossimi 500 giorni. Il canale ricomincerà a ricevere disponibilità e potrà accettare prenotazioni.",
    pauseText:
      "{code} verrà inviato a Channex per i prossimi 500 giorni. Il canale collegato a questa tariffa non potrà accettare nuove prenotazioni mentre è in pausa.",
    note: "Il calendario principale e gli altri canali non ne risentiranno. Per riprendere, clicca il pulsante ▶ sulla tariffa.",
    cancel: "Annulla",
    resuming: "Ripresa in corso...",
    pausing: "Messa in pausa...",
    confirmResume: "Sì, riprendi le vendite",
    confirmPause: "Sì, metti in pausa le vendite",
  },

  toast: {
    loadError: "Errore durante il caricamento dei dati",
    fillRequired: "Completa tutti i campi obbligatori",
    updated: "Tariffa aggiornata con successo",
    created: "Tariffa creata con successo",
    saveFailed: "Impossibile salvare la tariffa",
    saveError: "Errore durante il salvataggio della tariffa derivata",
    deleted: "Tariffa derivata eliminata",
    deleteFailed: "Impossibile eliminare la tariffa",
    deleteLinkedOta: "Impossibile eliminare: la tariffa è collegata a una OTA.",
    nameMismatch: "Il nome inserito non corrisponde.",
    deleteError: "Errore durante l'eliminazione della tariffa derivata",
    salesPaused: "Vendite in pausa",
    salesResumed: "Vendite riprese",
    toggleFailed: "Impossibile cambiare lo stato",
    toggleError: "Errore durante la modifica dello stato della tariffa",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "La tariffa è stata salvata, ma il channel manager non ha accettato la modifica: i canali restano con quella di prima. Controlla i dati e riprova.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "Soggiorno minimo proprio (notti)",
    hint: "Vuoto = lo stesso della tariffa principale",
    mixedPlaceholder: "Vari",
    mixedHint: "Ogni camera ha un minimo diverso. Se ne scrivi uno, verrà applicato a tutte; se lo lasci vuoto, ognuna mantiene il suo.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "Minimo {n} notte? | Minimo {n} notti?",
    suggestUse: "Usa",
    clear: "Rimuovi",
    channelNote: "{channel} riceverà un minimo di {n} notte per questa tariffa. | {channel} riceverà un minimo di {n} notti per questa tariffa.",
    genericNote: "I canali collegati (Booking, ecc.) riceveranno un minimo di {n} notte per questa tariffa. | I canali collegati (Booking, ecc.) riceveranno un minimo di {n} notti per questa tariffa.",
    chip: "Min. {n} notte | Min. {n} notti",
    chipMixed: "Min. diverso per camera",
    chipTitle: "Soggiorno minimo proprio di questa tariffa: viene inviato ai canali collegati",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "Togli il minimo a tutte",
    clearedAllHint: "Al salvataggio, tutte perderanno il loro minimo proprio e useranno quello della tariffa principale.",
    undo: "Annulla",
  },
};
